<template lang="pug">
.wagtail-paragraph(v-html="value")
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
.wagtail-paragraph h4 {
    font-size: 1.5rem;
    font-weight: 500;
    margin-bottom: 0.5rem;
    line-height: 1.2;
}
</style>